module.exports = __webpack_public_path__ + "img/Combined-Shape.4eab588e.svg";